import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';
import type { IRotationEntry } from 'uplisting-frontend/models/assignment-rule';

const CREATE_ATTRIBUTES = [
  'property_id',
  'kind',
  'mode',
  'required_acceptances',
  'multi_unit_ids',
  'inactive_user_ids',
];
const UPDATE_ATTRIBUTES = [
  'mode',
  'required_acceptances',
  'multi_unit_ids',
  'inactive_user_ids',
];

export default class AssignmentRuleSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    // @ts-expect-error - we have no typings for the json api
    const attributes = data.data.attributes as Record<string, unknown>;

    const picked = pick(
      attributes,
      snapshot.id ? UPDATE_ATTRIBUTES : CREATE_ATTRIBUTES,
    );

    if (this.#rotationChanged(snapshot)) {
      picked['user_ids'] = (attributes['rotation'] as IRotationEntry[]).map(
        (entry) => entry.user_id,
      );
    }

    // @ts-expect-error - we have no typings for the json api
    data.data.attributes = picked;

    return data;
  }

  #rotationChanged(snapshot: Snapshot): boolean {
    if (!snapshot.id) {
      return (snapshot.attr('rotation') as IRotationEntry[])?.length > 0;
    }

    return 'rotation' in snapshot.changedAttributes();
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'assignment-rule': AssignmentRuleSerializer;
  }
}
